import ScreeningAssessment, {
  ScreeningAssessmentProps,
} from "../ScreeningAssessment";
import { HOME_HEALTH_SCREENER_TYPES } from "../assessment-constant";

export type ObesityAssessmentProps = Omit<ScreeningAssessmentProps, "type">;

const ObesityAssessment = (props: ObesityAssessmentProps) => (
  <ScreeningAssessment {...props} type={HOME_HEALTH_SCREENER_TYPES.obesity} />
);

export default ObesityAssessment;
